import { CheckCircle2, ExternalLink, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function formatEur(n) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0,
  }).format(Number(n ?? 0));
}

/**
 * EmitDraftsResult — shown after emitir_borradores_batch executes.
 * Displays N emitted / errors and a deeplink to the sent invoices list.
 */
export default function EmitDraftsResult({ result }) {
  if (!result) return null;
  const errores = result.errores ?? 0;
  const ok = result.emitidas ?? 0;

  return (
    <div className="rounded-xl border border-success/30 bg-success/10 px-3 py-2.5 flex items-center justify-between gap-3 my-1 max-w-sm">
      <div className="flex items-center gap-2 min-w-0">
        <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
        <div className="min-w-0">
          <p className="text-xs font-semibold text-foreground">
            {ok} factura{ok !== 1 ? 's' : ''} emitida{ok !== 1 ? 's' : ''}
          </p>
          <p className="text-[10px] text-muted-foreground flex items-center gap-1">
            {formatEur(result.total)}
            {errores > 0 && (
              <span className="inline-flex items-center gap-0.5 text-destructive">
                · <AlertTriangle className="w-2.5 h-2.5" /> {errores} error{errores !== 1 ? 'es' : ''}
              </span>
            )}
          </p>
        </div>
      </div>
      <Link to="/facturas?tab=lista-v2&status=sent">
        <Button size="sm" variant="outline"
          className="h-7 text-[11px] shrink-0 gap-1 border-success/30 text-success hover:bg-success/10">
          Ver
          <ExternalLink className="w-3 h-3" />
        </Button>
      </Link>
    </div>
  );
}
